import React, { Component } from 'react'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
// import {TableComp} from 'sz-react-utils'
import TableComp from '../../../components/_utils/table'
import { FormUtils as GetAllFormFields } from 'sz-react-utils'

import ListFollowUps from '../../../components/_utils/listRawInquiryFollowUp'
import SyncSpreadsheetForm from '../../../components/_utils/syncSpreadsheetForm';

import LatestFollowUp from '../../../components/_utils/latestRawFollowup'

import moment from 'moment'
import { Button, Card, Drawer, Form, notification, Popconfirm, Select, Tooltip } from 'antd'
import Request, { API_URL, LAPI_URL } from '../../../request'
import _ from 'lodash'

import styles from './style.less'
import { connect } from 'react-redux'
import common from '../../common.less'
import { getUrlPushWrapper } from '../../../routes'
import { RightsWrapper } from '../../../components/_utils/utils'

import { hideLoader, showLoader } from '../../../modules/actions'

import rightAuth from '../../../components/_utils/userRights'
import ClickToCallDrawer from '../../Student/inquiry/all/clickToCall'


const Option = Select.Option

let studentObj = {}

const todayDate = moment().format('YYYYMMDD');

let sourceOptions = ['Direct', 'Newspaper', 'Facebook', 'Google',
    'Seminar', 'Education Fair', 'School/College Event', 'Conopy', 'Instagram', 'Justdial']

@Form.create()
class GoogleInquiry extends Component {

    state = {
        count: 0,
        allData: [],
        followDuesCount: 0,
        showFollowUp: false,
        visible: false,
        visible1: false,
        showSyncForm: false,
        allCounsellor: [],
        counsellorId: null,
        inquiryId: null,
        rawInquiryData: {},
        isFollowUpOverdue: false,
        showCallDrawer: false,
        recordForCall: {},
        showDropped: false,
        allModes: ['Personal', 'Telephone', 'Facebook', 'Website', 'Google', 'Global Expo 2023'],
        allTestTypes: [
            {
                value: 'ielts',
                text: 'IELTS'
            },
            {
                value: 'pte',
                text: 'PTE',
            },
            {
                value: 'no',
                text: 'NO'
            }
        ],
        allBranches: []
    }

    constructor(props) {
        super(props)
        this.table = React.createRef();
        this.followUpsCallback = this.followUpsCallback.bind(this);
    }

    saveCounsellorFxn = async (record) => {

        this.setState({ load: true })
        let x = await Request.saveCounsellor(record)

        if (x && !x.error) {

            notification.success({
                message: x.message
            })

            this.table.current.reload()
            this.setState({ load: false, visible: false })


        } else {
            notification.error({ message: 'Try again' })
        }


    }

    deleteRawInquiry = async (record) => {

        this.setState({ load: true })
        let x = await Request.deleteRawInquiry({ _id: record._id })

        if (x && !x.error) {

            notification.success({
                message: x.message
            })

            this.table.current.reload()
            this.setState({ load: false })


        } else {
            notification.error({ message: 'Try again' })
        }


    }

    moveRawInquiryToVisitor = async (record) => {
        this.setState({ load: true })
        let x = await Request.moveRawToVisitorVisa(record)
        if (x && !x.error) {
            notification.success({
                message: "Moved To Visitor Visa"
            })
        } else {
            notification.error({ message: 'Try again' })
        }

        this.setState({ load: false }, () => {
            this.table.current.reload()
        })
    }

    moveRawInquiry = async (record) => {

        this.setState({ load: true })
        if (!record.counsellorId) {
            return notification.error({ message: 'Counsellor Not Assigned' })
        } else {
            let x = await Request.moveAndDeleteRawInquiry(record)

            if (x && !x.error) {

                notification.success({
                    message: x.msg
                })

                this.table.current.reload()
                this.setState({ load: false })


            } else {
                notification.error({ message: 'Try again' })
            }
        }


    }

    handleSubmit = e => {
        const { dispatch, form } = this.props
        e.preventDefault()

        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {

                let values = _.clone(valData)

                let x = null

                x = await Request.addExcelData(values.excelFile[0].response)

                if (!x.error) {
                    notification.success({
                        message: x.message
                    })

                    this.setState({ visible1: false })
                    this.table.current.reload()
                } else {
                    notification.error({
                        message: x.message

                    })
                }
            }
        })
    }

    apiRequest = (params, columns) => {
        return new Promise(async resolve => {

            if (!params.sortField) {
                params.sortField = 'id'
                params.sortOrder = 'descend'
            }

            if (this.state.isFollowUpOverdue) {
                params.isFollowUpOverdue = this.state.isFollowUpOverdue;
            }
            params.dropped = this.state.showDropped;
            params.mode = 'Google';

            let data = await Request.getAllRawInquiryList({
                ...params,
                regExFilters: [
                    'studentName',
                    'email',
                    'mobile',
                    'createdByUser.name',
                    'updatedByUser.name',
                    'mode'
                ]
            })

            delete data.error
            delete data.type

            this.setState({ count: data.total, allData: data, allBranches: data.allBranches, followDuesCount: data.followUpsDuesCount })

            resolve(data)
        })
    }

    followUpsCallback(isFollowUpOverdue) {
        this.setState({
            isFollowUpOverdue: isFollowUpOverdue,
        }, () => {
            this.table.current.reload()
        });
    }

    openFollowUps = (record) => {
        studentObj = {
            name: record.studentName,
            _id: record._id,
        };
        this.setState({ showFollowUp: true });
    };

    closeFollowUp = () => {
        this.setState({ showFollowUp: false });
        this.reload();
    };

    closeSyncForm = () => {
        this.setState({ showSyncForm: false });
        this.reload();
    }

    onOk = (value) => {
        this.reload();
    };
    reload = () => {
        this.table.current.reload();
    };
    closeCallDrawer = () => {
        this.setState({ showCallDrawer: false, recordForCall: {} }, () => {
            this.reload()
        })
    }

    async componentDidMount() {


        let { data } = await Request.loadSimpleCounsellor({ results: 10000, atLevel: ['Counselling Desk'] })

        this.setState({
            allCounsellor: data, loading: false
        })

    }

    followUpExtendedDate = (followUp) => {
        if (followUp && followUp.followUpDate) {
            const followupDate = moment(followUp.followUpDate).format('YYYYMMDD');
            return todayDate >= followupDate ? true : false;
        }
    }

    render() {
        const { dispatch } = this.props
        const {
            form: { getFieldDecorator, getFieldValue }
        } = this.props
        let { allCounsellor, allModes, allTestTypes, allBranches } = this.state

        const columns = [
            {
                title: 'Actions',
                key: 'operation',
                dataindex: 'operation',
                fixed: true,
                width: 190,
                render: (text, record) => (
                    <div className={styles.btnWrapper}>
                        <Tooltip title="Choose Counsellor">
                            <Button
                                size={'small'}
                                shape="circle"
                                onClick={() => {
                                    this.setState({ visible: true, inquiryId: record._id })
                                }}
                                icon="user"
                            />
                        </Tooltip>
                        <Tooltip title="Edit Google Inquiry">
                            <Button
                                className={styles.btn}
                                size={'small'}
                                shape="circle"
                                style={{ marginLeft: '5px' }}
                                href={`/rawInquiry/edit-rawInquiry?id=${record._id}`}
                                icon="edit"
                            />
                        </Tooltip>

                        <RightsWrapper myRight={'Student.delete'}>
                            <Tooltip title="Delete Google Inquiry">
                                <Popconfirm
                                    title="Are you sure to delete this Google Inquiry?"
                                    onConfirm={() => {
                                        this.deleteRawInquiry({ _id: record._id })
                                    }}
                                    onCancel={() => {
                                        console.log()
                                    }}
                                    okText="Yes"
                                    cancelText="No">
                                    <Button
                                        className={styles.btn}
                                        size={'small'}
                                        style={{ marginTop: '5px', marginLeft: '5px' }}
                                        shape="circle"
                                        icon="delete"
                                    />
                                </Popconfirm>
                            </Tooltip>
                        </RightsWrapper>
                        <Tooltip title="Move To Visitor Visa">
                            <Popconfirm
                                title="Are you sure to move this Google Inquiry?"
                                onConfirm={() => {
                                    this.moveRawInquiryToVisitor(record)
                                }}
                                onCancel={() => {
                                    console.log()
                                }}
                                okText="Yes"
                                cancelText="No">
                                <Button
                                    className={styles.btn}
                                    size={'small'}
                                    style={{ marginLeft: '5px' }}
                                    shape="circle"
                                    icon="backward"
                                />
                            </Popconfirm>
                        </Tooltip>
                        <Tooltip title="Move Google Inquiry">
                            <Popconfirm
                                title="Are you sure to move this Google Inquiry?"
                                onConfirm={() => {
                                    this.moveRawInquiry(record)
                                }}
                                onCancel={() => {
                                    console.log()
                                }}
                                okText="Yes"
                                cancelText="No">
                                <Button
                                    className={styles.btn}
                                    size={'small'}
                                    style={{ marginLeft: '5px' }}
                                    shape="circle"
                                    icon="forward"
                                />
                            </Popconfirm>
                        </Tooltip>

                        <Tooltip title="View Notes">
                            <Button
                                className={styles.btn}
                                shape="circle"
                                size="small"
                                style={{ marginLeft: '5px' }}
                                onClick={() => this.openFollowUps(record)}
                                icon="eye"
                            />
                        </Tooltip>

                    </div>
                )
            },

            {
                title: 'ID',
                key: 'id',
                dataIndex: 'id',
                sorter: true,
                width: 80,
                fixed: true,
                searchTextName: 'id',
                filterRegex: true
            },
            {
                title: 'Student Name',
                key: 'studentName',
                dataIndex: 'studentName',
                sorter: true,
                fixed: true,
                width: 150,
                searchTextName: 'studentName',
                filterRegex: true,
                render: (text, record) => (
                    <React.Fragment>
                        <div
                            className={
                                this.followUpExtendedDate(record.followUp ? record.followUp : '') ? 'antd-pro-containers-student-inquiry-all-styles-followUpExtendedDate' : ''
                            }
                        >
                            <Tooltip title="View Student profile">
                                <a>{text}</a>
                            </Tooltip>
                        </div>
                    </React.Fragment>
                )
            },

            {
                title: 'DOB ',
                width: 100,
                key: 'dateOfBirth',
                dataIndex: 'dateOfBirth',
                searchDateName: 'dateOfBirth',
                render: (val, record) => {
                    return (
                        <div>
                            {record.dateOfBirth
                                ? moment(record.dateOfBirth).format('DD-MMM-YYYY')
                                : ''}
                        </div>
                    )
                }
            },

            {
                title: 'MOB/WAP/Mail',
                key: 'mobwap',
                dataIndex: 'mobwap',
                width: 150,
                searchTextName: 'MOB/WAP/Mail',
                render: (val, record) => {
                    return (
                        <div>
                            <div>
                                <span>
                                    {record.mobile && record.mobile.length >= 10 && rightAuth.checkRights("ShowClickToCall.view") ? (
                                        <Tooltip title="Start Call">
                                            <Button
                                                className="ant-btn ant-btn-primary"
                                                onClick={() => {
                                                    this.setState({ showCallDrawer: true, recordForCall: record })
                                                }}
                                            // onClick={(e) => {
                                            //   dispatch(showLoader());
                                            //   Request.callInitiate({
                                            //     mobile: record.mobile,
                                            //   }).then(({ data, error, message }) => {
                                            //     dispatch(hideLoader());
                                            //     if (!error) {
                                            //       notification.success({
                                            //         message: message,
                                            //       });
                                            //     } else {
                                            //       notification.error({
                                            //         message: message,
                                            //       });
                                            //     }
                                            //   });
                                            // }}
                                            >
                                                Click To Call
                                            </Button>
                                        </Tooltip>
                                    ) : (
                                        record.mobile
                                    )}</span>
                            </div>
                            <div>

                                {record.watsupp && record.watsupp.length == 10 ?
                                    <Tooltip title="Share on Whatsapp">
                                        <a target={'_blank'}
                                            style={{ textDecoration: 'underline' }}
                                            href={`http://api.whatsapp.com/send?phone=91${record.watsupp}&text=&source=&data=`}>{record.watsupp}</a>
                                    </Tooltip>
                                    : record.watsupp}

                            </div>
                            <div>
                                <span>{record.emailId}</span>
                            </div>
                        </div>
                    )
                }
            },
            {
                title: 'Preference',
                key: 'preference',
                searchTextName: 'preference',
                width: 200,
                filterRegex: true,
                render: (val, row) => {
                    return (
                        <div>
                            {
                                row.preference ?
                                    row.preference
                                    : row.totalPreference ? (
                                        <ul className={common.ul}>
                                            {row.totalPreference && row.totalPreference.length && row.totalPreference.map((val, inde) => {
                                                return <li key={inde}>{val && val.country ? val.country : ''}</li>
                                            })}
                                        </ul>
                                    ) : null
                            }
                        </div>
                    )
                }
            },
            {
                title: 'Case History',
                key: 'caseHistory',
                searchTextName: 'caseHistory',
                width: 200,
                filterRegex: true,
                render: (val, row) => {
                    return (
                        <div>{row.caseHistory}</div>
                    )
                }
            },
            {
                title: 'Follow Up',
                key: 'followUp',
                width: 200,
                dataIndex: 'followUp',
                render: (text, record) => {
                    return <LatestFollowUp info={text} />
                }
            },
            {
                title: 'Counsellor',
                key: 'counsellorId',
                width: 150,
                filters: allCounsellor.map(x => ({ value: x._id, text: x.name })),
                render: (text, record) => {
                    return (
                        <div>{record.counsellorId ? record.counsellorId.name : ''}</div>
                    )
                }
            },
            {
                title: 'Branch',
                key: 'studentBranchId',
                width: 120,
                filters: allBranches,
                render: (text, record) => {
                    return (<div>{record && record.studentBranchId && record.studentBranchId.branchName}</div>)

                }
            },
            {
                title: 'Source',
                key: 'location',
                width: 120
            },
            {
                title: 'Expo Visit',
                key: 'expoVisit',
                width: 120,
                filters: [
                    {
                        value: true,
                        text: 'Yes'
                    },
                    {
                        value: false,
                        text: 'No'
                    },
                ],
                render: (text, record) => {
                    return (
                        <div>
                            <div>{record.expoVisit ? 'Yes' : 'No'}</div>
                        </div>
                    )
                }
            },
            {
                title: 'Profile Completed',
                key: 'profileCompleted',
                width: 120,
                filters: [
                    {
                        value: true,
                        text: 'Yes'
                    },
                    {
                        value: false,
                        text: 'No'
                    },
                ],
                render: (text, record) => {
                    return (
                        <div>
                            <div>{record.profileCompleted ? 'Yes' : 'No'}</div>
                        </div>
                    )
                }
            },
            {
                title: 'Mode',
                key: 'mode',
                width: 120
            },
            {
                title: 'Test Type',
                key: 'testType',
                width: 110,
                filters: allTestTypes.map(x => ({ value: x.value, text: x.text }))
            },
            {
                title: 'Last Updated By',
                width: 150,
                key: 'updatedByUser',
                searchTextName: 'updatedByUser',
                filterRegex: true,
                dataIndex: 'updatedByUser',
                render: (text, record) => {
                    return (
                        <div>
                            <div className={common.user}>{text ? text.name : ''}</div>
                            <small>{text ? moment(text.time).format('lll') : ''}</small>
                        </div>
                    )
                }
            },
            {
                title: 'Created By',
                width: 150,
                key: 'createdByUser',
                searchTextName: 'createdByUser',
                filterRegex: true,
                dataIndex: 'createdByUser',
                render: (text, record) => {
                    return (
                        <div>
                            <div className={common.user}>{text ? text.name : ''}</div>
                            <small>{text ? moment(text.time).format('lll') : ''}</small>
                        </div>
                    )
                }
            }
        ]

        const inputTypes = {
            fields: [
                { label: 'Choose Excel File', key: 'excelFile', type: 'file', required: true }
            ]
        }

        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
                md: { span: 8 }
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
                md: { span: 12 }
            }
        }
        return (
            <PageHeaderWrapper title={` Google Inquiry List : ${this.state.count} `} subTitle={`Follow Up Overdue: ${this.state.followDuesCount}`} followUpsCallback={this.followUpsCallback}>

                {
                    this.state.showFollowUp ? (
                        <ListFollowUps studentObj={studentObj} onClose={this.closeFollowUp} />
                    ) : null
                }

                {
                    this.state.showSyncForm ? (
                        <SyncSpreadsheetForm onClose={this.closeSyncForm} />
                    ) : null
                }
                <RightsWrapper myRight={'syncGoogleEnquiry.view'}>
                    <Card>
                        {/* <Button
                        type={'primary'}
                        onClick={() => {this.setState({visible1: true})}}
                    >Add Excel File</Button> */}
                        &nbsp;&nbsp;&nbsp;
                        <Button
                            type={'primary'}
                            onClick={() => { this.setState({ showSyncForm: true }) }}
                        >Sync Google Leads</Button>

                    </Card></RightsWrapper>
                <Card bordered={true}>
                    <TableComp
                        showSelector={true}
                        columns={columns}
                        ref={this.table}
                        apiRequest={params => this.apiRequest(params, columns)}
                        extraProps={{ scroll: { x: 1400 } }}
                        pagination={{
                            showSizeChanger: true,
                            defaultPageSize: 20,
                            pageSizeOptions: ['10', '20', '50', '100', '1000']
                        }}
                    />
                </Card>

                {this.state.visible && <Drawer
                    title=""
                    placement="right"
                    closable={true}
                    onClose={() => {
                        this.setState({
                            visible: false
                        })
                    }}
                    visible={this.state.visible}
                    width={500}>
                    <div>
                        <Card style={{ marginBottom: '10px' }}>
                            <h2 style={{
                                marginLeft: '11px',
                                marginTop: '13px',
                                color: 'orange'
                            }}>Choose Counsellor</h2>

                            <div>
                                <Select
                                    showSearch={true}
                                    allowClear
                                    optionFilterProp="children"
                                    style={{
                                        width: 214,
                                        paddingRight: 16,
                                        paddingLeft: 9
                                    }}
                                    value={this.state.counsellorId ? this.state.counsellorId : undefined}
                                    placeholder="Select Counsellor"
                                    onChange={counsellorId => {
                                        this.setState(
                                            { counsellorId: counsellorId && counsellorId.toString() },
                                            () => {
                                                this.table.current.reload()
                                            }
                                        )
                                    }}
                                >
                                    {allCounsellor.map((val, idn) => {
                                        return (
                                            <Option key={idn} value={val._id}>
                                                {val.name}
                                            </Option>
                                        )
                                    })}
                                </Select>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    onClick={() => this.saveCounsellorFxn({
                                        _id: this.state.inquiryId ? this.state.inquiryId : '',
                                        counsellorId: this.state.counsellorId ? this.state.counsellorId : ''
                                    })}
                                    style={{ marginLeft: '1%' }}
                                    loading={this.state.loading}>
                                    SAVE
                                </Button>
                            </div>
                        </Card>
                    </div>
                </Drawer>}

                {
                    this.state.showCallDrawer ?
                        <ClickToCallDrawer record={this.state.recordForCall} type="rawInquiry" onClose={this.closeCallDrawer} />
                        : null
                }

                {this.state.visible1 && <Drawer
                    title=""
                    placement="right"
                    closable={true}
                    onClose={() => {
                        this.setState({
                            visible1: false
                        })
                    }}
                    visible={this.state.visible1}
                    width={500}>
                    <div>
                        <Card bordered={true}>
                            <div>

                                <Form onSubmit={this.handleSubmit} {...formItemLayout} style={{ marginTop: 8 }}>
                                    <GetAllFormFields apiurl={LAPI_URL}
                                        inputSchema={inputTypes}
                                        getFieldDecorator={getFieldDecorator} />

                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        style={{ marginLeft: '10%' }}
                                        loading={this.state.loading}>
                                        UPLOAD

                                    </Button>

                                    <a href={'../../../rawInquiry.xlsx'} download={'sample.xlsx'}>
                                        <Button
                                            type="default"
                                            style={{ marginLeft: '10%' }}
                                            loading={this.state.loading}>
                                            DOWNLOAD SAMPLE FILE
                                        </Button>
                                    </a>
                                </Form>

                            </div>


                        </Card>
                    </div>
                </Drawer>}

            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({ global }) => ({
    categories: global.categories
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(GoogleInquiry)
